import {Cookie} from "components/src/utils/Cookie";

function generateCookie()
{
    const token = crypto.randomUUID();

    Cookie.setCookie("XSRF-TOKEN", token, null, true, "Strict");

    return token;
}

function getCookie() {
    return Cookie.getCookie("XSRF-TOKEN") ?? ""
}

// Ensure a token exists from the moment this module is first imported.
// Components that need to POST before login (login form, signup, PDF reply, etc.)
// can rely on the cookie being present without calling generateCookie() themselves.
// Success.tsx calls generateCookie() explicitly after login to rotate the token.
if (!getCookie()) {
    generateCookie();
}

export const XSRF = () => {
    return
}

XSRF.generateCookie = generateCookie;
XSRF.getCookie = getCookie;
